import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { Container, NineSlicePlane, TextStyle, Text, Sprite, DEG_TO_RAD } from "pixi.js";
const WIDTH = 400;
export default class ScrollBtn extends Container {
  constructor(up) {
    super();
    this._up = up;
    this._init();
    this._initEvents();
    this._less = true;
  }
  _init(up) {
    this.btn = new NineSlicePlane(assets.textures.shopBtn.texture, 40, 40, 40, 40);
    // this.btn.scale.set(.7);
    this.btn.width = 200;
    this.btn.height = 90;
    this.btn.x = -100;
    this.addChild(this.btn);
    const textStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 27,
      align: "left",
      fill: 0xffffff,
      stroke: '#222222',
      strokeThickness: 5
    });
    this.arrow = new Sprite(assets.textures.arrow.texture);
    this.arrow.scale.set(.7);
    this.arrow.position.set(this.btn.width / 2, this.btn.height / 2);
    this.arrow.anchor.x = .5;
    this.arrow.anchor.y = .6;
    this.btn.addChild(this.arrow);
    if (this._up) {
      this.arrow.anchor.y = .2;
      this.arrow.rotation = DEG_TO_RAD * 180;
    } else {
      this.arrow.anchor.y = .6;
      this.arrow.rotation = 0;
    }
  }
  _initEvents() {
    this.interactive = true;
    this.buttonMode = true;
    this.on('pointerdown', this._onDown);
    this.on('pointerup', this._onUp);
    this.on('pointerupoutside', this._onOut);
  }
  _onDown() {
    if (this._isDown) {
      return;
    }
    this._isDown = true;
    this.onDownTween = gsap.to(this.scale, {
      duration: .2,
      x: .93,
      y: .93
    });
  }
  _onUp() {
    if (!this._isDown) {
      return;
    }
    this._isDown = false;
    this.onDownTween && this.onDownTween.kill();
    gsap.to(this.scale, {
      duration: .2,
      x: 1,
      y: 1
    });
    this.emit("onClick", this._up);
  }
  _onOut() {
    this._isDown = false;
    this.onDownTween && this.onDownTween.kill();
    gsap.to(this.scale, {
      duration: .2,
      x: 1,
      y: 1
    });
  }
}
